var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Styles
import { ContainerLegacy } from './ContainerLegacy';
// Utils
import styled from 'styled-components';
/**
 * @deprecated Do not use legacy components anymore.
 */
export var AnimatedContainer = styled(ContainerLegacy)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: ", ";\n  opacity: ", ";\n  ", ";\n"], ["\n  transition: ", ";\n  opacity: ", ";\n  ", ";\n"])), function (_a) {
    var transition = _a.transition;
    return (transition ? "".concat(transition) : null);
}, function (_a) {
    var opacity = _a.opacity;
    return (opacity ? "".concat(opacity) : 0);
}, function (_a) {
    var animate = _a.animate;
    return animate !== null && animate !== void 0 ? animate : 'animation: null';
});
var templateObject_1;
//# sourceMappingURL=AnimatedContainer.js.map